module.exports = __webpack_public_path__ + "static/img/14000675.578c050a.png";